import React from 'react';

const OrderPrint = ({ values, currencyDetail, distributorList }) => {

    const HandleOpenPDFSummary = (item) => {
        const url = `/pdf-order-summary?id=${item?.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const HandleOpenPDFDetail = (item) => {
        const url = `/pdf-order-detail?id=${item?.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="text-right">
            <div className="dropdown print-dropdown">

                <button
                    className="btn print-btn"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    data-display="static"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    Print <i className="fas fa-chevron-down ml-2"></i>
                </button>

                <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                >
                    <ul>
                        <li
                            onClick={(e) => {
                                e.preventDefault();
                                HandleOpenPDFSummary(values);
                            }}
                        >
                            <span>
                                Preview Summary
                            </span>
                        </li>

                        <li
                            onClick={(e) => {
                                e.preventDefault();
                                HandleOpenPDFDetail(values);
                            }}
                        >
                            <span>
                                Preview Detail
                            </span>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    );
};

export default OrderPrint;